import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import rootReducer from 'redux/reducers';
import rootSaga from 'redux/saga';

// 1. Initialize Saga Middleware with the DevTools monitor
const sagaMiddleware = createSagaMiddleware({
  sagaMonitor: window.__REDUX_DEVTOOLS_EXTENSION__?.sagaMonitor,
});

// 2. Configure DevTools to show Action Trace
const composeEnhancers = composeWithDevTools({
  trace: true, // This enables action tracing in the "Trace" tab
  traceLimit: 25, // Optional: adjust based on performance needs
});

const store = createStore(
  rootReducer,
  {},
  composeEnhancers(applyMiddleware(sagaMiddleware)),
);

const persistor = persistStore(store);
sagaMiddleware.run(rootSaga);

export { store, persistor };